import { createFileRoute } from '@tanstack/react-router';

import { DepartmentCreate } from '@/module/Department/DepartmentCreate';

export const Route = createFileRoute('/_auth/administration/_administration/department/_department/create')({
  component: RouteComponent,
});

function RouteComponent() {
  return <DepartmentCreate />;
}
